import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4c4b6ae6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "description-header-title"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description-header-content"
}, [/*#__PURE__*/_createElementVNode("span", null, "维护费率信息")], -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "费率描述", -1));
const _hoisted_4 = {
  style: {
    "margin-bottom": "10px"
  }
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, "费率明细", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_el_radio_button = _resolveComponent("el-radio-button");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_form = _resolveComponent("el-form");
  const _component_form_page = _resolveComponent("form-page");
  const _directive_permission = _resolveDirective("permission");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, {
    description: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(`${$data.edit ? '修改' : '增加'}费率`), 1)]), _hoisted_2]),
    _: 1
  }, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_form_page, null, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.formModel,
      rules: $data.formRules,
      class: "normal-form",
      ref: "formRef",
      "label-width": "180px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "隔日计费类型",
        prop: "nextDayType"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: $data.formModel.nextDayType,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.formModel.nextDayType = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_button, {
            label: "累计计费"
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "所属区域",
        prop: "areaId"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_cascader, {
          modelValue: $data.formModel.areaId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.formModel.areaId = $event),
          placeholder: "请选择区域信息",
          style: {
            "width": "40%"
          },
          props: $data.areaProps,
          options: $data.areas
        }, null, 8, ["modelValue", "props", "options"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "周末是否计费"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: $data.formModel.weekend,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.formModel.weekend = $event),
          prop: "weekend"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            label: "true",
            size: "large"
          }, {
            default: _withCtx(() => [_createTextVNode("计费")]),
            _: 1
          }), _createVNode(_component_el_radio, {
            label: "false",
            size: "large"
          }, {
            default: _withCtx(() => [_createTextVNode("不计费")]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "法定假日是否计费",
        prop: "holiday"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: $data.formModel.holiday,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.formModel.holiday = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            label: "true",
            size: "large"
          }, {
            default: _withCtx(() => [_createTextVNode("计费")]),
            _: 1
          }), _createVNode(_component_el_radio, {
            label: "false",
            size: "large"
          }, {
            default: _withCtx(() => [_createTextVNode("不计费")]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "封顶金额",
        prop: "maxFee"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: $data.formModel.maxFee,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.formModel.maxFee = $event),
          placeholder: "请输入封顶金额",
          step: 1,
          precision: 2,
          min: 0
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "超运营停放调度费用",
        prop: "outFenceFee"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: $data.formModel.outFenceFee,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.formModel.outFenceFee = $event),
          placeholder: "请输入超运营停放调度费用",
          step: 1,
          precision: 2,
          min: 0
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "站外停放调度费用",
        prop: "nonParkFee"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: $data.formModel.nonParkFee,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.formModel.nonParkFee = $event),
          placeholder: "请输入站外停放调度费用",
          step: 1,
          precision: 2,
          min: 0
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "生效日期",
        prop: "beginDay"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_date_picker, {
          modelValue: $data.formModel.beginDay,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.formModel.beginDay = $event),
          type: "date",
          placeholder: "请选择生效日期",
          format: "YYYY-MM-DD",
          "value-format": "YYYY-MM-DD",
          "disabled-date": $options.checkDay
        }, null, 8, ["modelValue", "disabled-date"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        prop: "feeDesc"
      }, {
        label: _withCtx(() => [_createElementVNode("div", null, [_hoisted_3, _createVNode(_component_el_popover, {
          trigger: "hover",
          content: "将显示在打印小票上"
        }, {
          reference: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "iconfont icon-question-circle",
            style: {
              "padding-left": "5px"
            }
          })]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formModel.feeDesc,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.formModel.feeDesc = $event),
          autosize: {
            minRows: 5,
            maxRows: 10
          },
          type: "textarea",
          placeholder: "请输入费率描述"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_el_divider), _createVNode(_component_el_table, {
        data: $data.formModel.items,
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "用户类型"
        }, {
          default: _withCtx(scope => [_withDirectives(_createElementVNode("p", null, _toDisplayString($options.showCarTypeDesc(scope.row.customerType)), 513), [[_vShow, !scope.row.editable]]), _withDirectives(_createVNode(_component_el_select, {
            modelValue: scope.row.customerType,
            "onUpdate:modelValue": $event => scope.row.customerType = $event,
            placeholder: "请选择"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.carTypeList, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"]), [[_vShow, scope.row.editable]])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "收费规则"
        }, {
          default: _withCtx(scope => [_withDirectives(_createElementVNode("p", null, _toDisplayString($options.showFeeRuleCode(scope.row.dayFeeRuleId)), 513), [[_vShow, !scope.row.editable]]), _withDirectives(_createVNode(_component_el_select, {
            modelValue: scope.row.dayFeeRuleId,
            "onUpdate:modelValue": $event => scope.row.dayFeeRuleId = $event,
            placeholder: "请选择",
            filterable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.feeRuleList, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.code,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"]), [[_vShow, scope.row.editable]])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "默认",
          width: "70px"
        }, {
          default: _withCtx(scope => [_withDirectives(_createElementVNode("p", null, _toDisplayString(scope.row.defaultItem ? '是' : '否'), 513), [[_vShow, !scope.row.editable]]), _withDirectives(_createVNode(_component_el_checkbox, {
            modelValue: scope.row.defaultItem,
            "onUpdate:modelValue": $event => scope.row.defaultItem = $event,
            onChange: v => {
              $options.defaultItemChange(scope.row, v);
            }
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]), [[_vShow, scope.row.editable]])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [scope.row.editable ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            onClick: $event => $options.saveItem(scope.row),
            type: "success"
          }, {
            default: _withCtx(() => [_createTextVNode("确定 ")]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true), !scope.row.editable ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            link: "",
            onClick: $event => scope.row.editable = true,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("修改 ")]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
            link: "",
            onClick: $event => $options.deleteItem(scope.row),
            type: "danger"
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: $options.addItem
        }, {
          default: _withCtx(() => [_createTextVNode("增加费率明细")]),
          _: 1
        }, 8, ["onClick"]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: $options.submitForm
        }, {
          default: _withCtx(() => [_createTextVNode("保存 ")]),
          _: 1
        }, 8, ["onClick"])), [[_directive_permission, ['feeStandardRuleAudit_add', 'feeStandardRuleAudit_edit']]]), _createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = () => {
            this.$router.go(-1);
          })
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  })]);
}